import React, { useCallback } from "react";
import { useLanguageContext } from "../../../Context/LanguageContext";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import printJS from "print-js";
import { Button, Menu, MenuItem } from "@mui/material";
export default function ChartExport({ keyOfChart, refValue, rows }) {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const optionList1 = [
    { Name: localization.downloadExcel, value: "excel" },
    { Name: localization.downloadPdf, value: "pdf" },
    { Name: localization.printLabel, value: "print" },
  ];
  const convertCanvasToImage = async () => {
    const dashboard = document.getElementById(
      keyOfChart === "EquiStatusDistribution"
        ? "equipmentKpiRef"
        : keyOfChart === "InspectionKpi"
        ? "inspectionKpiRef"
        : keyOfChart === "TicketKpi"
        ? "ticketKpiRef"
        : "OrgKpiRef"
    );

    const datePickers = dashboard.querySelectorAll(".MuiInputBase-root input");
    const dateValues = [];
    const replacedElements = [];

    datePickers.forEach((input) => {
      const value = input?.value || "";
      dateValues.push(value);

      const parent = input.parentElement;
      if (parent) {
        const span = document.createElement("span");
        span.textContent = value || "No Date Selected";
        span.style.padding = "6px 12px";
        span.style.border = "1px solid #ccc";
        span.style.borderRadius = "4px";
        span.style.backgroundColor = "#f9f9f9";
        parent.replaceChild(span, input);
        replacedElements.push({ parent, input, span });
      }
    });

    // Generate the canvas
    const canvas = await html2canvas(dashboard, { scale: 2 });

    // Restore the original DatePicker inputs
    replacedElements.forEach(({ parent, input, span }) => {
      if (parent && input && span) {
        parent.replaceChild(input, span);
      }
    });

    // Convert canvas to PNG image
    const imgData = canvas.toDataURL("image/png");
    return { imgData, canvas, dashboard };
  };

  const generatePDF = async () => {
    const { imgData, canvas, dashboard } = await convertCanvasToImage();
    const pdf = new jsPDF();
    const imgWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
    pdf.save("dashboard.pdf");
    dashboard.style.overflow = "auto";
    dashboard.style.height = "";
    setGlobalSpinner(false);
  };

  const printCharts = async () => {
    const { imgData } = await convertCanvasToImage();

    printJS({
      printable: imgData,
      type: "image",
      header: false,
      style: `
        @media print {
         @page {
        margin: 0; /* Removes extra margins */
    }
    body {
        margin: 0; /* Ensures the content aligns to the edges */
    }
          body { margin: 0; }
          #chartHeaderBarRef {
            display: flex !important;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #DADADA;
            padding-top: 8px;
            margin-bottom: 16px;
          }
          .MuiButton-root {
            white-space: nowrap;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 6px 8px;
            text-transform: none;
          }
        }
      `,
    });
    setGlobalSpinner(false);
  };

  const exportToExcel = (_rowsValue) => {
    setGlobalSpinner(true);
    const workbook = XLSX.utils.book_new();

    _rowsValue.forEach((row, rowIndex) => {
      row.sections.forEach((section, sectionIndex) => {
        const { heading, chartData } = section;
        const labelColumnName =
          chartData.datasets[0]?.excelData?.columnName || "Label";
        // Prepare data for the worksheet
        const data = [
          [labelColumnName, ...chartData.datasets.map((ds) => ds.label)], // Header row
          ...chartData.labels.map((label, i) => [
            label,
            ...chartData.datasets.map((ds) => ds.data[i] || 0), // Data rows
          ]),
        ];

        // Convert data to a worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(data);

        // Append the worksheet to the workbook
        // Name it dynamically using row and section indices or the heading
        const sheetName = heading;
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
      });
    });

    // Trigger file download
    XLSX.writeFile(workbook, "DashboardData.xlsx");
    setGlobalSpinner(false);
  };

  const handelExport = useCallback(
    (_value, index) => {
      setGlobalSpinner(true);
      switch (_value) {
        case "pdf": {
          generatePDF();
          break;
        }
        case "excel": {
          exportToExcel(rows);
          break;
        }
        case "print": {
          printCharts();
        }
      }
    },
    [rows]
  );
  const handleExportClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleExportClose = (newState) => {
    if (newState) {
      handelExport(newState, 1);
    }
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        variant="contained"
        endIcon={<ArrowDropDownIcon />}
        onClick={handleExportClick}
        style={{ height: "32px", padding: "6px 8px 6px 8px" }}
        className="gridTableButton gridTableButtonStyle"
      >
        {localization.exportTitle}
      </Button>{" "}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleExportClose(null)}
      >
        {optionList1.map((item, index) => (
          <MenuItem
            key={index}
            style={{ fontSize: "16px" }}
            onClick={() => handleExportClose(item.value)}
          >
            {item.Name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
